import gettext from '@sdk/lang/gettext';
import Tooltip from '@sdk/common/tooltip/Tooltip';

import { PathnameEnum } from '@web/Router/router.types';
import { generatePath } from '@web/Router/router.utils';
import FilingBoxIcon from '@web/assets/svg/UI/filing-box.svg';
import { ConversationBasic } from '@web/conversations/types/Conversation';
import { useScrollbarGutterFallback } from '@web/common/hooks/useScrollbarGutterFallback';
import { useGroupConversationsPremiumGuard } from '@web/conversations/hooks/useGroupConversationsPremiumGuard';
import SecureSvg from '@web/assets/svg/Icons/16/secure.svg';

import { Item, ItemLink, List, ToggleButton, Wrapper } from './archivedGroup.styles';

type Props = {
  items: ConversationBasic[];
};

// @FIXME ToggleButton should be <button />, not <label />
// and the tabIndexes, blur onClick will not be required,
// but let safari 1st fix it's 14yrs old bug
// https://bugs.webkit.org/show_bug.cgi?id=22261
export const ArchivedGroup = ({ items }: Props) => {
  const { setRef, shouldApplyFallback } = useScrollbarGutterFallback();
  const { areGroupConversationsEnabled, tooltipContent } = useGroupConversationsPremiumGuard();

  return (
    <Wrapper>
      <ToggleButton tabIndex={-1}>
        <FilingBoxIcon /> {gettext('Archived conversations')}
      </ToggleButton>
      <List ref={setRef} shouldApplyFallback={shouldApplyFallback}>
        {items.map((conversation) => (
          <div
            key={conversation.id}
            data-for="archived-conversation-tooltip"
            data-tip={!conversation.isPrivate ? tooltipContent : ''}
            data-place="top">
            <Item isActive={areGroupConversationsEnabled || conversation.isPrivate}>
              <ItemLink
                onClick={(e) => e.currentTarget.blur()}
                tabIndex={-1}
                to={generatePath(PathnameEnum.CONVERSATION_DETAILS, {
                  params: { id: conversation.id, slug: conversation.slug },
                })}>
                {conversation.name}
                {!areGroupConversationsEnabled && !conversation.isPrivate && <SecureSvg />}
              </ItemLink>
            </Item>
          </div>
        ))}
      </List>

      <Tooltip attachToBody id="archived-conversation-tooltip" maxWidth={230} />
    </Wrapper>
  );
};
